import { Header, HomeLanding, FirstContentA, FirstContentB, FirstContentC, Transition1, Transition2, SecondContent, Footer, ContactForm, ContactIntro, ThirdContent } from '../../components';
import { meltenEffect, scrollNum } from '../../utils/Effects';


async function scrollEffects() {
  meltenEffect('third-comp-quote');
  meltenEffect('third-comp-quote-author');
  meltenEffect('third-comp-transi-sent');
  meltenEffect('third-comp-ind-1', 100);
  meltenEffect('third-comp-ind-2', 250);
  meltenEffect('third-comp-ind-3', 400);

  meltenEffect('FirstContentA-wrapper');
  meltenEffect('first-compA-slogan');
  meltenEffect('first-compA-description');
  meltenEffect('first-compA-right-side', 400);
  meltenEffect('first-compB-slogan');
  meltenEffect('first-compB-description');
  meltenEffect('first-compB-left-side', 400);
  meltenEffect('first-compC-slogan');
  meltenEffect('first-compC-description');
  meltenEffect('first-compC-right-side', 400);
  meltenEffect('transition-text-1');
  meltenEffect('transition-text-2');
  meltenEffect('transition-pic');
  meltenEffect('contact-intro-text');
  meltenEffect('contact-form-wrapper');
  meltenEffect('contact-datas');
  await scrollNum('percent-to-up-1', 21.6, 1200);
  await scrollNum('percent-to-up-3', 17.1, 1000);
}



window.addEventListener("scroll", scrollEffects);
window.addEventListener("touchmove", scrollEffects);

function Home() {


  return (
    <>
      <Header title='home' />
      <main className="flex flex-col text-primary">
        <HomeLanding />
        <Transition1 />
        <ThirdContent />
        <FirstContentA />
        <FirstContentB />
        <FirstContentC />
        <Transition2 />
        <SecondContent />
        <ContactIntro />
        <ContactForm />
        <Footer />
      </main>
    </>
  );
}

export default Home;